export const PLAYER_SCRUB_SECONDS = 5;
